import React from "react";
import { useTranslation } from "react-i18next";

import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import { Box, Typography, useTheme } from "@mui/material";

import { useDir } from "../hooks";

const EVOX_PINK = "#f14295";

const VoucherNextStepHint = () => {
  const { t } = useTranslation();
  const dir = useDir();
  const theme = useTheme();

  return (
    <Box
      role="note"
      dir={dir}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.75,
        width: { xs: "100%", sm: "fit-content" },
        maxWidth: "100%",
        marginTop: 1.5,
        position: "sticky",
        top: { xs: theme.spacing(18), md: theme.spacing(10) },
        zIndex: theme.zIndex.appBar - 1,
        paddingBlock: 0.75,
        paddingInline: 1.25,
        border: "1px solid",
        borderColor: EVOX_PINK,
        borderRadius: 1.5,
        backgroundColor: "rgba(254, 241, 247, 0.96)",
        boxShadow: "0 3px 12px rgba(52, 55, 65, 0.08)",
        backdropFilter: "blur(6px)",
        color: "text.primary",
        textAlign: "start",
      }}
    >
      <LocalOfferOutlinedIcon
        aria-hidden="true"
        sx={{ color: EVOX_PINK, fontSize: 19, flexShrink: 0 }}
      />
      <Typography variant="body2" sx={{ lineHeight: 1.5 }}>
        {t("subscription.voucherNextStepHint")}
      </Typography>
    </Box>
  );
};

export default VoucherNextStepHint;
